<script setup lang="ts">
import { twMerge } from 'tailwind-merge'

type TProps = {
  variant?: 'primary'
}

const VARIANTS = {
  primary: 'bg-p-500 border border-white text-black font-semibold leading-none',
}

const props = withDefaults(defineProps<TProps>(), { variant: 'primary' })
const classes = computed(() => VARIANTS[props.variant] || '')
</script>

<template>
  <div :class="twMerge(['py-1 px-4 text-sm rounded-full', classes])">
    <slot />
  </div>
</template>
